module.exports = __webpack_public_path__ + "static/img/eyes_04.bd65cac.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/eyes/thumbnail/eyes_04.png
// module id = CsfW
// module chunks = 0